import { FC } from "react";

import { Box } from "@mui/material";

import { DashboardTypography } from "@/dashboard-design-system/Typography/DashboardTypography";

interface LifecycleChipProps {
  status: string | null;
}

const OPEN_VALUES = new Set(["open", "posted", "accepting", "active"]);
const FORECASTED_VALUES = new Set(["forecasted", "forecast", "anticipated"]);
const CLOSED_VALUES = new Set(["closed", "archived", "inactive", "expired"]);

export const LifecycleChip: FC<LifecycleChipProps> = ({ status }) => {
  if (!status) {
    return null;
  }
  const normalized = status.trim().toLowerCase();
  const isOpen = OPEN_VALUES.has(normalized);
  const isForecasted = FORECASTED_VALUES.has(normalized);
  const isClosed = CLOSED_VALUES.has(normalized);

  const palette = isOpen
    ? { bg: "#DCFCE7", fg: "#15803D" }
    : isForecasted
      ? { bg: "#FEF3C7", fg: "#B45309" }
      : isClosed
        ? { bg: "#F1F5F9", fg: "#475569" }
        : { bg: "rgba(85,85,231,0.10)", fg: "#3F3FA8" };

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.5,
        px: 1.25,
        py: 0.25,
        borderRadius: 999,
        backgroundColor: palette.bg,
        whiteSpace: "nowrap",
      }}
    >
      <Box aria-hidden sx={{ width: 6, height: 6, borderRadius: "50%", backgroundColor: palette.fg, opacity: 0.85 }} />
      <DashboardTypography
        variant="caption"
        sx={{
          color: palette.fg,
          fontWeight: 600,
          textTransform: "capitalize",
          letterSpacing: 0.3,
        }}
      >
        {normalized.replace(/_/g, " ")}
      </DashboardTypography>
    </Box>
  );
};
